import { render, staticRenderFns } from "./CurrentEntitiesOverView.vue?vue&type=template&id=3e610c3c&"
import script from "./CurrentEntitiesOverView.vue?vue&type=script&lang=js&"
export * from "./CurrentEntitiesOverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports